import React, { useEffect } from 'react'
import hotkeys from 'hotkeys-js'

import { TwoColumnContent } from '~layouts/ReferenceLayout'
import { render } from '~utils/rehype-render'

import style from './Endpoint.module.scss'

import { 
  Output, 
  Button, 
  Control,
  Alert
} from '~components/Explorer'

import UrlBar from './UrlBar'
import Navigation from './Navigation'
import Request from './Request'
import Responses from './Responses'
import CodeSamples from './CodeSamples'
import ResponseExample from '~components/ResponseExample'
import RelatedGuides from './RelatedGuides'

const Endpoint = ({
  explorer,
  endpoint,
  microcopy
}) => {
  useEffect(() => {
    hotkeys('command+e,ctrl+e', function(event){
      event.preventDefault() 
      explorer.enable()
    })  
  }, [])

  return (
    <div className={ style.reference }>
      <TwoColumnContent>
        <>
          <Alert explorer={explorer} />
          <Button explorer={explorer} endpoint={endpoint} offset='extra' />
          <h1>{ endpoint.title }</h1>
          <UrlBar endpoint={ endpoint } />
          <Navigation endpoint={endpoint} microcopy={microcopy} />
          <div className={style.summary}>{ render(endpoint.descriptionAst) }</div>

          <RelatedGuides guides={endpoint.relatedGuides} microcopy={microcopy} />
          <Request 
            explorer={explorer}
            endpoint={endpoint}
            microcopy={microcopy} />
          <Responses 
            microcopy={microcopy}
            explorer={explorer}
            endpoint={endpoint} />
          <Control explorer={explorer} />

        </>
        <div className={ style.examples }>
          <CodeSamples endpoint={endpoint} microcopy={microcopy} />
          <Output explorer={explorer} />
          { endpoint.defaultResponse?.resource && <ResponseExample code={ endpoint.defaultResponse?.resource.jsonExample } />}
          
        </div>
      </TwoColumnContent>
    </div>
  )
}

export default Endpoint
export { style }